import type {
  SingleValueGridRequiredProps,
  SingleValueGridSparklineRequiredProps,
  SingleValueGridTrendRequiredProps,
} from './types/single-value-grid.js';

export const DISPLAY_NAME = 'SingleValueGrid';

export const sparklineDefaultProps: SingleValueGridSparklineRequiredProps = {
  showTicks: false,
  showContextValues: false,
  variant: 'line',
  curve: 'linear',
  gapPolicy: 'connect',
  className: '',
  style: {},
  'data-testid': '',
  'data-dtrum-mask': false,
  'data-dtrum-allow': false,
  'data-dt-name': '',
  'data-dt-content': '',
  'data-dt-children-name': '',
  'data-dt-features': '',
  'data-dt-properties': '',
  'data-dt-mouse-over': '',
  'data-dt-value-content': false,
  'data-dt-children-value-content': false,
  'data-dt-ancestor': '',
};

export const trendDefaultProps: SingleValueGridTrendRequiredProps = {
  showIcon: true,
  inverseTrend: 'none',
};

export const gridDefaultProps: SingleValueGridRequiredProps = {
  alignment: 'start',
  applyThresholdBackground: false,
  className: '',
  style: {},
  'data-dtrum-mask': false,
  'data-dtrum-allow': false,
  'data-testid': '',
  loading: false,
  'data-dt-name': '',
  'data-dt-content': '',
  'data-dt-children-name': '',
  'data-dt-features': '',
  'data-dt-properties': '',
  'data-dt-mouse-over': '',
  'data-dt-value-content': false,
  'data-dt-children-value-content': false,
  'data-dt-ancestor': '',
};

export const SINGLE_VALUE_GRID_ARIA_LABEL =
  'Single value data visualization grid';
